<template>
  <b-row>
    <b-col cols="12">
      <okr-edit-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import OkrEditForm from './OkrEditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    OkrEditForm,
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
